var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInputPasswordShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.26109 0.406494L1.37637 0.585615C2.99303 2.93794 5.79701 4.50509 8.99981 4.50509C12.2019 4.50509 15.0053 2.93867 16.6221 0.587276L16.7335 0.411269L18.0009 1.21354L17.8821 1.40134C17.8772 1.40905 17.8722 1.41666 17.867 1.42418C15.9717 4.18981 12.7016 6.0051 8.99981 6.0051C5.29833 6.0051 2.02847 4.19012 0.13309 1.42489C0.12899 1.41891 0.124977 1.41287 0.121053 1.40677L-0.000244141 1.21831L1.26109 0.406494ZM8.25029 7.99997L8.25029 11H9.75029L9.75029 7.99997H8.25029ZM2.51317 6.50472L1.01317 9.00472L2.29941 9.77647L3.79941 7.27647L2.51317 6.50472ZM16.9872 9.00472L15.4872 6.50472L14.2009 7.27647L15.7009 9.77647L16.9872 9.00472Z",
    fill: "#101828",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputPasswordShow);
export default __webpack_public_path__ + "static/media/input-password-show.a7c92c7a95d347d1c506d557c719c89b.svg";
export { ForwardRef as ReactComponent };